import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { combineReducers } from 'redux';
import { defaultTrolley } from '../../config';
import { PREPARE_TROLLEY_REQUEST, UPDATE_TROLLEY_FIELD, UPDATE_TROLLEY_SETUP, ADD_TROLLEY_ITEM, REMOVE_TROLLEY_ITEM, PROCESS_TROLLEY_REQUEST, COMPLETE_TROLLEY_REQUEST, FAIL_TROLLEY_REQUEST } from '../actions';
import { calculateTotal } from '../helpers';
/**
 * Manage trolley requests
 * @method trolleyRequestsReducer
 */

export var trolleyRequestsReducer = function trolleyRequestsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case PREPARE_TROLLEY_REQUEST:
      {
        var partNumber = action.partNumber;
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, partNumber, _objectSpread(_objectSpread({}, defaultTrolley), {}, {
          partNumber: partNumber
        })));
      }

    case UPDATE_TROLLEY_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.partNumber, _objectSpread(_objectSpread({}, state[action.partNumber]), {}, _defineProperty({}, action.field, action.fieldValue))));

    case UPDATE_TROLLEY_SETUP:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.partNumber, _objectSpread(_objectSpread({}, state[action.partNumber]), action.setup)));

    default:
      return state;
  }
};
/**
 * Manage trolley items and their state
 * @method trolleyItemsReducer
 */

export var trolleyItemsReducer = function trolleyItemsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isProcessing: false,
    inProgress: [],
    added: [],
    failed: [],
    total: 0,
    trolleyRequestComplete: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_TROLLEY_ITEM:
      {
        var inProgress = state.inProgress.filter(function (item) {
          return item !== action.partNumber;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          isProcessing: inProgress.length > 0,
          inProgress: inProgress,
          added: _toConsumableArray(new Set([].concat(_toConsumableArray(state.added), [action.partNumber])))
        });
      }

    case REMOVE_TROLLEY_ITEM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          added: state.added.filter(function (item) {
            return item !== action.partNumber;
          })
        });
      }

    case PROCESS_TROLLEY_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isProcessing: true,
          inProgress: _toConsumableArray(new Set([].concat(_toConsumableArray(state.inProgress), [action.partNumber])))
        });
      }

    case COMPLETE_TROLLEY_REQUEST:
      {
        var requestTotal = calculateTotal(action.payload);
        return _objectSpread(_objectSpread({}, state), {}, {
          total: state.total + requestTotal,
          trolleyRequestComplete: true
        });
      }

    case FAIL_TROLLEY_REQUEST:
      {
        var partNumber = action.partNumber,
            error = action.error;
        return _objectSpread(_objectSpread({}, state), {}, {
          failed: [].concat(_toConsumableArray(state.failed), [{
            partNumber: partNumber,
            error: error
          }])
        });
      }

    default:
      return state;
  }
};
export var trolleyReducer = combineReducers({
  items: trolleyItemsReducer,
  requests: trolleyRequestsReducer
});